// src/services/api.js
import axios from 'axios';
//import { parseStringPromise } from 'xml2js';
//import SHA256 from 'crypto-js/sha256';
export const fetchAppSettings = async (eventId) => {
    try {
        console.log(eventId);
        // const url = `https://www.eventscribeapp.com/app/containers/ContainerInfo2019-01.asp?containerID=${eventId}`;
        // const response = await axios.get(url, {
        //     headers: {
        //         'x-origin': 'https://www.eventscribe.com', // Add the Origin header 
        //     },
        // });

        // // Parse XML response
        // const result = await parseStringPromise(response.data, { explicitArray: false });

        // Access root level tag (usually <container> or similar)
         //const container = result?.container;
         const container = null;

        // if (!container) throw new Error('Invalid XML structure');

        // Extract required values
        return {
            loginButtonColor: container.lginBtnColor || '#0077cc',
            navBackgroundColor: container.navBgColor || '#ffffff',
            navForegroundColor: container.navFgColor || '#000000',
        };
    } catch (error) {
       // console.error('Error fetching app settings:', error);
        // Default fallback colors
        return {
            loginButtonColor: '#0077cc',
            navBackgroundColor: '#ffffff',
            navForegroundColor: '#000000',
        };
    }
};

export const fetchToken = async (url, token) => {
    try {
        
        const response = await axios.get(url,   {
            method:"GET",
            headers: {
                Authorization: `Bearer ${token}`,                
                Accept: 'application/json',
                
            }
        });

        if (response.status !== 200 || !response.data.UserToken) {
            throw new Error('Failed to fetch token');
        }

        return { token: response.data.UserToken, expireat: response.data.ExpiresAt};
    } catch (error) {
        console.error('Error fetching token:', error);
        throw error;
    }
};


 
export const loginToSystem = async ({ url, data }) => {
    // Ensure accountid is provided
    if (!data) throw new Error('Invalid request');  
    // Prepare form data
    const formData = new URLSearchParams();
    formData.append('data', data); 
    try {
        // Make the POST request using axios
        const response = await axios.post(url, formData, {
            headers: { 
                'Content-Type': 'application/x-www-form-urlencoded', // Use form-urlencoded
                Accept: 'application/json', // Ensure the server knows we expect JSON
                
            }, withCredentials: true, // Add this if cookies are involved
        });

        // Extract and return the required fields
        const responseData = response.data;
        return {
            AccessToken: responseData.AccessToken,
            TokenType: responseData.TokenType || '',
            AccountID: responseData.AccountID,
            AccountKey: responseData.AccountKey,
            ClientID: responseData.ClientID,
            EventID: responseData.EventID,
            EventKey: responseData.EventKey,
            AccessLevel: responseData.AccessLevel,
            RegType: responseData.RegType || '',
            FirstName: responseData.FirstName,
            LastName: responseData.LastName,
            DaysUntil: responseData.DaysUntil,
        };
    } catch (error) {
        // Log and rethrow the error
        const errorMessage = error.response?.data || error.message || 'Login failed';
        console.error('Error logging in:', errorMessage);
        throw new Error(errorMessage);
    }
};


